<div class="paginate text-center">
  <div class="d-flex">
    <div>
      <button *ngIf="!isDiabledFirst" class="btn" (click)="onClickGoto(0)">First</button>
      <span *ngIf="isDiabledFirst" class="btn disabled">First</span>
    </div>
    <div>
      <button *ngIf="!isDiabledFirst" class="btn" (click)="onClickGoto(paginate.currentPage - 1)">Previous</button>
      <span *ngIf="isDiabledBack" class="btn disabled">Previous</span>
    </div>

    <div class="flex-grow-1">
      <ng-container *ngFor="let btn of pageButtons">
        <button *ngIf="btn.page !== undefined" class="btn" (click)="onClickGoto(btn.page)"
          [class.current]="btn.current">
          {{ btn.title }}
        </button>
        <span class="mx-1" *ngIf="btn.page === undefined"> {{ btn.title }}</span>
      </ng-container>
    </div>

    <div>
      <button *ngIf="!isDiabledNext" class="btn" (click)="onClickGoto(paginate.currentPage + 1)">Next</button>
      <span *ngIf="isDiabledNext" class="btn disabled">Next</span>
    </div>
    <div>
      <button *ngIf="!isDiabledLast" class="btn" (click)="onClickGoto(paginate.pageLength - 1)">Last</button>
      <span *ngIf="isDiabledLast" class="btn disabled">Last</span>
    </div>
  </div>
</div>